export default __webpack_public_path__ + "static/media/blue-door.feb64aa6.gif";